function getFriendlyResultsCount(results, includeBngProperties, maxResults) {

    return results == null ? ('Loading ' + getThing(true, includeBngProperties) + '...') :
        results.TotalResults > 0 ? (results.TotalResults + ' ' + getThing(results.TotalResults > 1, includeBngProperties) + ' found' +
        (results.TotalResults > maxResults ? ' (showing ' + maxResults + ')' : ''))
        : 'No ' + getThing(true, includeBngProperties) + ' found';
}

function getThing(plural, isBng) {
    return isBng ? (plural ? "habitat banks" : "habitat bank")
        : (plural ? "properties" : "property");
}

export { getFriendlyResultsCount }